import React, { useEffect, useState } from "react";

import { IconNotFocused } from "components/local_modal/talk_time/icon_not_focused";
import { useUserIdsWithCapability } from "hooks/capabilities";
import { useAppSelector } from "hooks/redux_hooks";
import { useUsersProperties } from "hooks/use_user_properties";
import { CapabilityType, KeyboardShortcutSignalType } from "shared/types";
import { classroomSelectors, localSelectors } from "store";
import { getTalkTimeColor } from "utils/talk_time";

const OVERLAY_OPACITY_OFF = 0;
const OVERLAY_OPACITY_ON = 0.7;

function TalkTimeOverlay({ userId, noIcon = false }: { userId: string; noIcon?: boolean }) {
  const users = useUsersProperties(["classroom_talk_time"]);
  const canParticipateInClassUserIds = useUserIdsWithCapability(
    CapabilityType.CAN_PARTICIPATE_IN_CLASS,
  );
  const keyboardShortcutSignal = useAppSelector(localSelectors.selectKeyboardShortcutSignal());
  const [overlayOpacity, setOverlayOpacity] = useState(OVERLAY_OPACITY_OFF);

  useEffect(() => {
    if (keyboardShortcutSignal === KeyboardShortcutSignalType.ToggleTalkTimeOverlay) {
      setOverlayOpacity(OVERLAY_OPACITY_ON);
    } else {
      setOverlayOpacity(OVERLAY_OPACITY_OFF);
    }
  }, [keyboardShortcutSignal]);

  const userHasClassroomInFocus = useAppSelector(
    classroomSelectors.selectUserHasClassroomInFocus(userId),
  );

  if (!canParticipateInClassUserIds.includes(userId)) return null;

  const talkTimeColor = getTalkTimeColor(userId, users, canParticipateInClassUserIds);

  return (
    <>
      <div
        className={`absolute top-0 right-0 bottom-0 left-0 bg-${talkTimeColor}`}
        style={{ opacity: overlayOpacity, transition: "opacity 300ms ease-in-out" }}
        data-testid={`talk-time-overlay-${userId}-${talkTimeColor}`}
      />
      {!userHasClassroomInFocus && !noIcon && (
        <div
          className="absolute top-0 right-0 bottom-0 left-0 flex items-center justify-center"
          style={{ opacity: overlayOpacity, transition: "opacity 300ms ease-in-out" }}
        >
          <IconNotFocused size="60%" />
        </div>
      )}
    </>
  );
}

export { TalkTimeOverlay };
